import './App.css';
import React from 'react';
import MainLayout from './Containers/MainLayout';
import { AuthContextProvider } from './Context/authContext';
import ThemeProvider from './Utils/themeProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './Utils/i18next/i18n.js';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-phone-input-2/lib/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AppContextProvider } from './Context/appContext';
import { FormContextProvider } from './Context/formContext';
import { BrowserRouter } from 'react-router-dom';
// import { Worker } from '@react-pdf-viewer/core';

// import * as Sentry from '@sentry/react';
// import { CaptureConsole } from '@sentry/integrations';

// try {
//   Sentry.init({
//     dsn: 'https://283b043ae989901391219e11b9a9759a@o4506267918663680.ingest.sentry.io/4506381165199360',
//     integrations: [
//       new Sentry.BrowserTracing({
//         tracePropagationTargets: ['localhost:3000', /^https:\/\/apply-flame-stage\.ken42\.com\//],
//       }),
//       new Sentry.Replay(),
//       new CaptureConsole({ levels: `['error']` }),
//     ],
//     debug: true,
//     // Performance Monitoring
//     tracesSampleRate: 1.0, // Capture 100% of the transactions
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   });
//   window.onerror = function (message, source, lineno, colno, error) {
//     Sentry.captureException(error);
//     console.error('Uncaught error:', error);
//   };
// } catch (error) {
//   console.error('Sentry initialization error:', error);
// }

function App() {
  return (
    <BrowserRouter>
      <AppContextProvider>
        <FormContextProvider>
          <AuthContextProvider>
            <ThemeProvider>
              <I18nextProvider i18n={i18n}>
                <div className="App">
                  <MainLayout />
                </div>
              </I18nextProvider>
            </ThemeProvider>
          </AuthContextProvider>
        </FormContextProvider>
      </AppContextProvider>
    </BrowserRouter>
  );
}

export default App;
